import * as React from "react";
import { Spinner } from "../../../../../../react-core/Html/Spinner";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { LoadingSkeletonType } from "../../../../../Shared/LoadingSkeleton/Contents";
import { LoadingSkeletonWrapper } from "../../../../../Shared/LoadingSkeleton/LoadingSkeletonWrapper";
import MoneyDisplayWithUpperDecimal from "../../../../../Shared/Money/MoneyDisplayWithUpperDecimal.component";

interface IAumTileProps {
    title: string;
    amount: number;
    includeOperator?: boolean;
    isLoading: boolean;
}

const AumTile = (props: IAumTileProps) => {
    return (
        <div className="aum-tile">
            <h3 className="text mb-0">{props.title}</h3>
                <LoadingSkeletonWrapper
                    isLoading={props.isLoading}
                    skeletonType={LoadingSkeletonType.Simple}
                >
                    <MoneyDisplayWithUpperDecimal
                        amount={{
                            Currency: CurrencyCode.GBP,
                            Amount: props.amount,
                        }}
                    />
                    {(props.includeOperator == null || props.includeOperator) && <div className="operator" />}
                </LoadingSkeletonWrapper>            
        </div>
    );
};

export default AumTile;
